module.exports = __webpack_public_path__ + "media/mlg_airhorn.02727bb6.mp3";